import {
  DataProvider,
  IErrorModel,
  IPauseSubscriptionModel,
  useMutation,
} from "@nf/common";
import { IUnpauseSubscriptionRequestModel } from "@nf/common/src/providers/DataProvider/Skymill/models";

export const useUnpauseSubscription = () => {
  return useMutation<
    IPauseSubscriptionModel,
    IErrorModel,
    IUnpauseSubscriptionRequestModel
  >((data) => DataProvider.unpauseSubscription(data));
};
